import React from 'react';
import BaseField, { BaseFieldProps } from '../../Inputs/BaseField/BaseField';
import CSSZInsuranceAdministratorSelect, {
	type CSSZInsuranceAdministratorSelectProps,
} from './CSSZInsuranceAdministratorSelect';
import { SelectValue } from '../../../../../Components/Base/Select/Select';
import { TermItem } from '../../../../../graphql/graphql';

interface Props extends BaseFieldProps {
	onChange?: (value: SelectValue, termItem?: TermItem) => void;
}

type CSSZInsuranceAdministratorSelectBridgeProps = Omit<
	CSSZInsuranceAdministratorSelectProps,
	'onChange'
> & {
	onChange?: (value: SelectValue) => void;
	onAdministratorChange?: (value: SelectValue, termItem?: TermItem) => void;
};

const CSSZInsuranceAdministratorSelectBridge: React.FC<
	CSSZInsuranceAdministratorSelectBridgeProps
> = ({ value, onChange: fieldOnChange, onAdministratorChange, ...rest }) => (
	<CSSZInsuranceAdministratorSelect
		{...rest}
		value={value}
		onChange={(selectValue, termItem) => {
			fieldOnChange?.(selectValue);
			onAdministratorChange?.(selectValue, termItem);
		}}
	/>
);

const CSSZInsuranceAdministratorSelectField: React.FC<Props> = ({
	onChange: onAdministratorChange,
	...baseFieldProps
}) => (
	<BaseField {...baseFieldProps}>
		<CSSZInsuranceAdministratorSelectBridge
			onAdministratorChange={onAdministratorChange}
		/>
	</BaseField>
);

export default CSSZInsuranceAdministratorSelectField;
